<template>
    <div class="pages__vacatures__card">
        <h3>{{ titel }}</h3>
        <div class="pages__vacatures__card__buttons">
            <p class="button" @click="$emit('click_edit', v_id)"><i class="fa-solid fa-pen-to-square"></i>Bewerk</p>
        </div>
    </div>
</template>
<script>
export default {
    props:["id", "titel"],
    data(){
        return{
            v_id: this.$props.id
        }
    }
}
</script>